import { Checkbox } from '@material-ui/core';
import React from 'react';

import { Row, Rows } from '~/src/dash/components/layout';
import { Text } from '~/src/dash/publicaUI';
import { IMenuList } from '~/src/dash/types/menuList';
import { useBulkUpdateChannelGroupStore } from '~/src/dash/views/bulk-update-channel-groups/contexts';

interface IBulkUpdateSidebarProps {
  channelGroupsLength: number;
  selectedValuesToUpdate: Record<string, IMenuList>;
  activeFields: Record<string, boolean>;
  deselect: (field: string) => void;
}

export const BulkUpdateSidebar = ({
  channelGroupsLength,
  selectedValuesToUpdate,
  activeFields,
  deselect,
}: IBulkUpdateSidebarProps) => {
  const { cfg } = useBulkUpdateChannelGroupStore();
  const { sideBar, valuesToUpdate } = cfg;

  return (
    <Row
      style={{
        backgroundColor: 'rgb(245, 245, 245)',
        width: '35%',
      }}
    >
      {Object.values(sideBar).map(({ rowTitle, rowDescription }) => (
        <Rows>
          <Text subheader>{rowTitle}</Text>
          <Text
            small
            style={{
              paddingBottom: '8px',
            }}
          >
            {rowTitle === 'Channel Groups' ? channelGroupsLength + rowDescription : rowDescription}
          </Text>
        </Rows>
      ))}
      {activeFields &&
        Object.entries(activeFields).map(([field, value]) => {
          const updateValue = selectedValuesToUpdate[field];
          let displayValueString;
          switch (typeof updateValue) {
            case 'object':
              const fieldValueLength = Object.keys(updateValue).length;
              const updatedMenuTitle =
                fieldValueLength > 1
                  ? valuesToUpdate[field].menuTitle
                  : valuesToUpdate[field].singularTitle;
              displayValueString = `${fieldValueLength} ${updatedMenuTitle} applied to Channel Groups`;
              break;
            default:
              displayValueString = `${updateValue}`;
          }
          return (
            <>
              {!!value && (
                <Row noPadding>
                  <Checkbox
                    onClick={() => deselect(field)}
                    checked={!!selectedValuesToUpdate[field]}
                  />
                  {displayValueString}
                </Row>
              )}
            </>
          );
        })}
    </Row>
  );
};
